import { useState, useEffect, useRef } from 'react';
import { useJoyrideContext } from '../../contexts/JoyrideContext';

export default function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const { state: joyRideState } = useJoyrideContext();
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (joyRideState?.run) return; // ⛔ Ignore clicks while Joyride running
        if (ref.current && !ref.current.contains(event?.target)) {
            setIsComponentVisible(false);
        }
    };

    const handleClick = (event) => {
        if (ref.current && ref.current.contains(event?.target)) {
            setIsComponentVisible((prevValue) => !prevValue);
        } else {
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [joyRideState?.run]);

    return { ref, isComponentVisible, setIsComponentVisible, handleClickOutside, handleClick };
}